import React, { Suspense, useState, useEffect, useRef } from "react";
import SuspenseComponent from "../../components/SuspenseComponent";
import InsightsTable from "./InsightsTable";
import InsightsSubmitDateRange from "./InsightsSubmitDateRange";
import { getInsights } from "API";
import { Row, Col } from "reactstrap";

const Insights = () => {
    const [valueDateRange, setValueDateRange] = useState(() => {
        const now = new Date();
        const endOfToday = new Date(now);
        endOfToday.setHours(23, 59, 59, 999);
        const weekAgo = new Date(now);
        weekAgo.setDate(weekAgo.getDate() - 7);
        weekAgo.setHours(0, 0, 0, 0);
        return [weekAgo, endOfToday];
    });

    const [insightsData, setInsightsData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const isRequestInProgress = useRef(false);

    const fetchInsights = async (startRange, endRange) => {
        if (isRequestInProgress.current) return; // block multiple requests
        isRequestInProgress.current = true;
        setIsLoading(true);
        try {
            const response = await getInsights({ startRange, endRange });
            if (response?.status === 200) {
                setInsightsData(response.data?.data || {});
            } else {
                setInsightsData([]);
            }
        } catch (error) {
            console.error("Failed to fetch insights:", error);
            setInsightsData([]);
        } finally {
            setIsLoading(false);
            isRequestInProgress.current = false;
        }
    };

    // Initial fetch on first render
    useEffect(() => {
        fetchInsights(valueDateRange[0], valueDateRange[1]);
    }, []);

    // Fetch on date range change
    useEffect(() => {
        fetchInsights(valueDateRange[0], valueDateRange[1]);
    }, [valueDateRange]);

    const handleSubmit = () => {
        fetchInsights(valueDateRange[0], valueDateRange[1]);
    };

    return (
        <div className="content">
            <Row className="mb-3">
                <Col lg="3">
                    <h4>Insights</h4>
                </Col>
            </Row>

            <Row className="mb-3">
                <InsightsSubmitDateRange
                    valueDateRange={valueDateRange}
                    setValueDateRange={setValueDateRange}
                    handleSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </Row>

            <Suspense fallback={<SuspenseComponent />}>
                <InsightsTable
                    loading={isLoading}
                    valueDateRange={valueDateRange}
                    data={insightsData}
                />
            </Suspense>
        </div>
    );
};

export default Insights;
